/**
 * src/hooks/useCountdown.js — Server-synced countdown.
 *
 * Uses the server-provided `getCountdown` function instead of
 * the client's local Date(). Every user sees the same countdown
 * regardless of timezone or OS clock manipulation.
 */

import { useEffect } from 'react';

const useCountdown = (setCountdown, isPaused, getCountdown) => {
    useEffect(() => {
        if (isPaused) return;

        const update = () => {
            if (getCountdown) {
                setCountdown(getCountdown());
            } else {
                // Fallback if server time not yet synced
                const now = new Date();
                setCountdown(60 - now.getSeconds());
            }
        };

        update();
        const interval = setInterval(update, 1000);
        return () => clearInterval(interval);
    }, [setCountdown, isPaused, getCountdown]);
};

export default useCountdown;
